import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/create',
      name: 'create-room',
      component: () => import('@/views/CreateRoomPage.vue')
    },
    {
      path: '/join/:roomId?',
      name: 'join-room',
      component: () => import('@/views/JoinRoomPage.vue')
    },
    {
      // Invite link: room code in the path, role inside the signed token (no
      // query params). JoinRoomPage joins the room and passes the token along.
      path: '/i/:roomId/:token',
      name: 'invite',
      component: () => import('@/views/JoinRoomPage.vue')
    },
    {
      path: '/room/:roomId',
      name: 'room',
      component: () => import('@/views/RoomPage.vue')
    },
    {
      // Donde termina una sesión: salir de la sala (o que te saquen de ella)
      // llevaba a la portada comercial de la plataforma, que no es una página
      // para alumnos ni profesores. `?room=` permite volver a entrar y
      // `?reason=` distingue haber salido de que te hayan expulsado.
      path: '/session-ended',
      name: 'session-ended',
      component: () => import('@/views/SessionEndedPage.vue')
    },
    {
      // Loaded by LiveKit Egress (headless Chrome) to compose server-side
      // recordings. Not a user-facing page — it reads ?url=&token= from the
      // egress and renders the clean grid.
      path: '/rec',
      name: 'recording',
      component: () => import('@/views/RecordingView.vue')
    }
  ]
})

export default router